import { formatMessage } from '../components/LocaleProvider/LocaleProvider';

export default function translate(id, params) {
  if (params instanceof Object) {
    return formatMessage({ id: id }, params);
  } else {
    return formatMessage({ id: id });
  }
}
